import { CircleLayerSpecification } from "maplibre-gl";
import { AppState } from "../AppState.ts";

const LICORICE_GRAY = "#3F3F46";
const LOCAL_BRAND_BASE_URL = "https://www.finn.no";
const PRODUCTION_BRAND_BASE_URL = `${window.location.origin}`;
const SOLD_PROPERTIES_PATH = "/map/realestate/sold";

type coordinate = {
	lat: number;
	lon: number;
};

export const soldPropertiesLayer: CircleLayerSpecification = {
	id: "sold-properties-layer",
	type: "circle",
	source: "sold-properties-source",
	paint: {
		"circle-radius": ["case", ["boolean", ["feature-state", "hover"], false], 11, 8],
		"circle-color": LICORICE_GRAY,
		"circle-opacity": 1,
		"circle-stroke-color": "#FFF",
		"circle-stroke-width": 1.5,
	},
};

export function addSoldPropertiesHoverEffects(map: maplibregl.Map) {
	map.on("mousemove", "sold-properties-layer", (e) => {
		map.getCanvas().style.cursor = "pointer";

		const hoveredFeatureId = e.features?.[0].id as number;
		map.setPaintProperty("sold-properties-layer", "circle-radius", [
			"match",
			["id"],
			hoveredFeatureId,
			11,
			soldPropertiesLayer.paint?.["circle-radius"],
		]);
	});

	map.on("mouseleave", "sold-properties-layer", () => {
		map.getCanvas().style.cursor = "";
		map.setPaintProperty(soldPropertiesLayer.id, "circle-radius", soldPropertiesLayer.paint?.["circle-radius"]);
	});
}

export function onSoldPropertiesClick(map: maplibregl.Map, state: AppState) {
	map.on("click", "sold-properties-layer", (e) => {
		//get the feature that was clicked
		const feature = e.features?.[0];

		if (!feature) {
			console.error("No feature found", e);
			return;
		}

		const { id: featureId, lon, lat } = feature.properties;
		const coordinate: coordinate = { lat, lon };
		const zoom = map.getZoom();

		setFeatureValuesInAppState(coordinate, featureId, zoom, state);

		const mapUrl = openSoldPropertiesOnMapPage(coordinate, zoom);

		window.dispatchEvent(
			new CustomEvent("sold-property-click", {
				detail: { adId: featureId, mapUrl },
			}),
		);
	});
}

function getBrandUrlFromLocationOrigin() {
	return window.location.hostname.includes("local") ? LOCAL_BRAND_BASE_URL : PRODUCTION_BRAND_BASE_URL;
}

function openSoldPropertiesOnMapPage(coordinate: coordinate, zoom: number): string {
	const brandUrlFromLocationOrigin = getBrandUrlFromLocationOrigin();

	const url = new URL(SOLD_PROPERTIES_PATH, brandUrlFromLocationOrigin);

	url.searchParams.append("lat", coordinate.lat.toString());
	url.searchParams.append("lon", coordinate.lon.toString());
	url.searchParams.append("zoom", zoom.toString());

	window.open(url);

	return url.toString();
}

function setFeatureValuesInAppState(coordinates: coordinate, featureId: string, zoom: number, state: AppState) {
	const featureCoordinats: [number, number] = [coordinates.lat, coordinates.lon];
	state.adCoordinates = featureCoordinats;
	state.adId = featureId;
	state.zoomLevel = zoom;
}
